import { render, staticRenderFns } from "./editPromoPaymentOption.vue?vue&type=template&id=155f26c6&lang=pug"
import script from "./editPromoPaymentOption.vue?vue&type=script&lang=js"
export * from "./editPromoPaymentOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports